<div class="container-fluid glb-popup">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <mat-icon>close</mat-icon>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="row m-0">

        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100"
                style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="name" id="name" type="text" pInputText>
            <label for="name">Name</label>
            @for (validation of validationMessages.name; track validation) {
              <span>
                @if (form1.get('name').hasError(validation.type) && (form1.get('name').dirty || form1.get('name').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <p-dropdown class="w-100" [options]="statuses" formControlName="status" optionLabel="name"
            optionValue="value" placeholder="Status"></p-dropdown>
            <label for="Status">Status</label>
            @for (validation of validationMessages.status; track validation) {
              <span>
                @if (form1.get('status').hasError(validation.type) && (form1.get('status').dirty || form1.get('status').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <p-calendar formControlName="contractDate" inputId="contractDate" appendTo="body">
            </p-calendar>
            <label for="contractDate">Contract Date</label>
            @for (validation of validationMessages.contractDate; track validation) {
              <span>
                @if (form1.get('contractDate').hasError(validation.type) && (form1.get('contractDate').dirty || form1.get('contractDate').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="billingType" id="billingType" type="text" pInputText>
            <label for="billingType">Billing Type</label>
            @for (validation of validationMessages.billingType; track validation) {
              <span>
                @if (form1.get('billingType').hasError(validation.type) && (form1.get('billingType').dirty || form1.get('billingType').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <textarea formControlName="publicDesc" id="publicDesc" [rows]="1" pInputTextarea></textarea>
            <label for="publicDesc">Public Desc</label>
            @for (validation of validationMessages.publicDesc; track validation) {
              <span>
                @if (form1.get('publicDesc').hasError(validation.type) && (form1.get('publicDesc').dirty || form1.get('publicDesc').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <textarea formControlName="opsNotes" id="opsNotes" [rows]="1" pInputTextarea></textarea>
            <label for="opsNotes">Ops Notes</label>
            @for (validation of validationMessages.opsNotes; track validation) {
              <span>
                @if (form1.get('opsNotes').hasError(validation.type) && (form1.get('opsNotes').dirty || form1.get('opsNotes').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

      </div>
    </div>
    <hr>
      @if (activityProviderId) {
        <app-activity-list (closeDialog)="closeDialog($event)" [activityProviderId]="activityProviderId" [showFilter]="false" [showPagination]="false"></app-activity-list>
      }
      <hr>
        <div class="row m-0">
          <div class="col-lg-12">
            <div class="btn-group">
              <div class="button-group">
                @if (activityProviderId) {
                  <button pButton class="btn-delete p-button-outlined p-button-danger"
                  (click)="onFormDelete()">Delete Activity Provider</button>
                }
              </div>

              <div class="button-group">
                <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
                @if (!activityProviderId) {
                  <button pButton class="btn-addt p-button" (click)="formAdd()">Add Activity Provider</button>
                }

                @if (activityProviderId) {
                  <button pButton  class="btn-upt p-button" (click)="formUpdate()">Update Activity Provider</button>
                }
              </div>
            </div>
          </div>
        </div>
      </div>

